export const REQUEST = 'Clients/REQUEST';
export const SUCCESS = 'Clients/SUCCESS';
export const ERROR = 'Clients/ERROR';

export const SET = 'Clients/SET';
export const DELETED = 'Clients/DELETED';
export const UPDATED = 'Clients/UPDATED';
export const ADDED = 'Clients/ADDED';